import { render, staticRenderFns } from "./ToDistributorModel.vue?vue&type=template&id=74637195&scoped=true&"
import script from "./ToDistributorModel.vue?vue&type=script&lang=ts&"
export * from "./ToDistributorModel.vue?vue&type=script&lang=ts&"
import style0 from "./ToDistributorModel.vue?vue&type=style&index=0&id=74637195&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74637195",
  null
  
)

export default component.exports